import RequestService from "../../services/RequestService";
import FormBase from "../FormBase";
import FormFieldBase from "../../forms/FormFieldBase";
import ValidationBase, { ValidationType } from "../../forms/ValidationBase";
import Professional from '../../models/Professional'
import { RegiaoOptions } from "../../data/Regiao";
import { TipoCadastroCorpoClinicoOptions } from "../../data/TipoCadastroCorpoClinico";


export default class PersonalAddressDataForm implements FormBase {

    TypeRegistration: FormFieldBase;
    Sector: FormFieldBase;
    Region: FormFieldBase;

    constructor(typeRegistration: any, sector: string, region: string) {
        this.TypeRegistration = new FormFieldBase(typeRegistration, [new ValidationBase("", ValidationType.OBRIGATORIO)]);
        this.Sector = new FormFieldBase(sector, [new ValidationBase("", ValidationType.CUSTOM)], ((value: any) => { return this.ValidateFieldCustom(value) }));
        this.Region = new FormFieldBase(region, [new ValidationBase("", ValidationType.OBRIGATORIO)]);
    }


    ValidateFieldCustom(value: any): string {
        if (this.TypeRegistration.Value === "MedicoTerceiro" && value === "") {
            return "O Campo é obrigatório."
        } else {
            return "";
        }
    }

    static NewInstance(): PersonalAddressDataForm {
        return new PersonalAddressDataForm("", "", "");
    }

    async CallInsertOrUpdateApi(Professional: Professional): Promise<any> {
        const dataJson = this.getJsonObjet();
        return RequestService.postCreateOrUpdateRequest(dataJson, Professional.Id);
    }

    ValidateToGoNextStep(): string {
        let propNames = Object.getOwnPropertyNames(this);

        let formIsValid = true;

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            const error = this.GetFieldByName(element).ValidateField();

            if (error !== null && error !== "") {
                formIsValid = false;
            }
        }

        if (!formIsValid) {
            return "Por favor, preencha os dados obrigatórios."
        } else {
            return "";
        }
    }

    GetFieldByName(name: string): FormFieldBase {

        switch (name) {

            case "TypeRegistration":
                return this.TypeRegistration

            case "Sector":
                return this.Sector

            case "Region":
                return this.Region

            default:
                return new FormFieldBase("", []);
        }
    }

    getJsonObjet() {

        return {
            "ProfessionalId": 0,
            "RequestTypeRegistration": {
                "Id": TipoCadastroCorpoClinicoOptions.find(r => r.value === this.TypeRegistration.Value)?.id,
                "Name": TipoCadastroCorpoClinicoOptions.find(r => r.value === this.TypeRegistration.Value)?.text
            },
            "RequestType": {
                "Id": 1,
                "Name": 'Corpo Clínico'
            },
            "RequestRegion": RegiaoOptions.find(r => r.value === this.Region.Value)?.id,
            "Sector": this.Sector.Value,
        }
    }

}